<template>
  <div class="no-result flex-ccc" :style="bodyStyle">
      <div class="no-result-img" :class="type"></div>
      <div>{{text || '暂无数据'}}</div>
    </div>
</template>

<script>
  export default {
    name: 'noData',
    props: [ 'text', 'type', 'bodyStyle' ]
  }
</script>
<style  scoped lang="stylus">
  .no-result
    height 50vh
    .no-result-img
      width 93px
      height 88px
      background-image url($url +'noData-record.png')
      background-size: 93px 88px
      background-position center
      margin 20px
      &.coupon
        background-image url($url +'noData-coupon.png')
      &.card
        background-image url($url +'noData-card.png')
      &.address
        background-image url($url +'noData-address.png')
      &.goods
        background-image url($url +'noData-goods.png')
      &.record
        background-image url($url +'noData-record.png')
      &.order
        background-image url($url +'noData-order.png')
</style>
